import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import LeftMenuDesign from '../../../../components/common/LeftMenuDesign/LeftMenuDesign';
import { listHandle } from '../../../../dataTest/data';
// import { fetchDoorHandles } from '../../../../store/actions/door.handle.action';
import './LeftPartitionDesignMenu.scss';
import { getValueFromString } from '../../../../utils/data/getValue.utils';
import CardProduct from '../../../../components/card/CardProduct/CardProduct';
import CardProductClick from '../../../../components/card/CardProduct/CardProductClick';

const LeftPartitionDesignMenu = ({ open, onClickCard, title }) => {
  const dispatch = useDispatch();

  const { door } = useSelector(state => state.doorAndHandle || {});

  const [searchParams] = useSearchParams();
  // const productType = searchParams.get('product_type') || '';

  // useEffect(() => {
  //   if (!productType) return;
  //   dispatch(
  //     fetchDoorHandles({ product_type: productType, door_type: 'HINGED' })
  //   );
  // }, [dispatch, productType]);

  return (
    <LeftMenuDesign
      open={open}
      classNames={{
        root: '!left-[60px] relative',
        content: '!p-0 gap-0',
      }}
      styles={{ content: { background: '#F7F7F7' } }}
      header={
        <>
          <span className="text-title-large text-nowrap">{title}</span>
        </>
      }
      content={
        <>
          <div className="grid grid-cols-2 p-8 justify-start items-start gap-2 self-stretch overflow-auto">
            {/* {listHandle.map((md, i) => { */}
            {door?.data?.handles?.map((md, i) => {
              const name = getValueFromString(md.name);
              const description = getValueFromString(md.description);
              return (
                <CardProductClick
                  key={i}
                  md={md}
                  title={name}
                  description1={md.size}
                  description2={description}
                  // description2={
                  //   <span className="text-label-small">
                  //     {md.price.toLocaleString('vi-VN', {
                  //       style: 'currency',
                  //       currency: 'VND',
                  //     })}
                  //   </span>
                  // }
                  moduleType={'moduleType'}
                  onClick={onClickCard}
                  // onlyForAll={true}
                />
              );
            })}
          </div>
        </>
      }
    />
  );
};

export default LeftPartitionDesignMenu;
